import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  keys = {
    token: 'NextGen-Auth-Token',
    secretaryId: 'NextGen-Secretary-Id',
    isTest: 'NextGen-IsTest',
  };
  constructor() {}

  async setObj(key: string, value: any) {
    await Preferences.set({
      key: key,
      value: JSON.stringify(value),
    });
  }

  async getEntity<T>(key: string): Promise<T> {
    const obj = await Preferences.get({ key });
    return obj && obj.value ? JSON.parse(obj.value) : null;
  }

  async setItem(key: string, value: string) {
    await Preferences.set({
      key: key,
      value: value,
    });
  }

  async getItem(key: string) {
    const { value } = await Preferences.get({ key });
    return value;
  }

  async removeItem(key: string) {
    await Preferences.remove({ key });
  }

  async getStorageKeys() {
    const { keys } = await Preferences.keys();
    return keys;
  }

  async purge() {
    await Preferences.clear();
  }
}
